import { UserOutlined } from '@ant-design/icons'
import KItem from 'app/components/Modules/General/KItem'
import React, { ComponentProps } from 'react'

import { MemberProps } from '../convention'

type Props = Partial<ComponentProps<typeof KItem>>

const ContactDetail: React.FC<MemberProps<IContact, Props>> = ({ member: contact, props }) => {
  return (
    <KItem
      avatar={<UserOutlined className="font-size-22" />}
      description={contact?.tel}
      verticalAlign
      title={
        <span className="font-weight-normal font-family-base text-black">{contact?.name}</span>
      }
      {...props}
    />
  )
}

export default ContactDetail
